<template>
	<v-responsive class="overflow-visible">
		<v-card class="mx-1 mt-4" :disabled="!$hasScope(['root', 'admin'])">
			<v-card-title>
				<v-layout align-center>
					<span class="subtitle-2"><v-icon color="blue" small class="mr-2">mdi-minus</v-icon>핀 누적 집계</span>
				</v-layout>
			</v-card-title>
			<v-divider/>
			<v-simple-table dense>
				<tbody class="text-end">
					<tr>
						<th class="text-end">전체</th>
						<th class="text-end">미발행</th>
						<th class="text-end">발행완료</th>
						<th class="text-end">취소완료</th>
					</tr>
					<tr>
						<td>{{ summaries.reduce((totalCount, summary) => totalCount + +summary.totalCount, 0)?.format?.() }}건</td>
						<td>{{ summaries.reduce((totalCount, summary) => totalCount + (summary.status == "미발행" ? summary.totalCount : 0), 0)?.format?.() }}건</td>
						<td>{{ summaries.reduce((totalCount, summary) => totalCount + (summary.status == "발행완료" ? summary.totalCount : 0), 0)?.format?.() }}건</td>
						<td>{{ summaries.reduce((totalCount, summary) => totalCount + (summary.status == "취소완료" ? summary.totalCount : 0), 0)?.format?.() }}건</td>
					</tr>
					<tr>
						<td>{{ summaries.reduce((totalAmount, summary) => totalAmount + summary.totalCount * summary.faceamt, 0)?.format?.() }}원</td>
						<td>{{ summaries.reduce((totalAmount, summary) => totalAmount + (summary.status == "미발행" ? summary.totalCount * summary.faceamt : 0), 0)?.format?.() }}원</td>
						<td>{{ summaries.reduce((totalAmount, summary) => totalAmount + (summary.status == "발행완료" ? summary.totalCount * summary.faceamt : 0), 0)?.format?.() }}원</td>
						<td>{{ summaries.reduce((totalAmount, summary) => totalAmount + (summary.status == "취소완료" ? summary.totalCount * summary.faceamt : 0), 0)?.format?.() }}원</td>
					</tr>
					<tr></tr>
				</tbody>
			</v-simple-table>
		</v-card>

		<v-card class="mx-1 mt-4" :disabled="!$hasScope(['root', 'admin'])">
			<v-card-title>
				<v-layout align-center>
					<span class="subtitle-2"><v-icon color="blue" small class="mr-2">mdi-minus</v-icon>핀 목록</span>
					<v-spacer/>
					<v-btn :disabled="!$route.params._giftcard" color="green" outlined height="36" class="my-auto mr-2" @click="excel">
						<v-icon left>{{ mdiMicrosoftExcel }}</v-icon>
						<span>엑셀파일 다운로드</span>
					</v-btn>
					<v-btn :disabled="!$route.params._giftcard" color="green" outlined height="36" class="my-auto mr-2" :to="`/console/shop/giftcards/${$route.params._giftcard}/stock`">
						<v-icon left>{{ mdiMicrosoftExcel }}</v-icon>
						<span>재고관리 페이지</span>
					</v-btn>
				</v-layout>
			</v-card-title>
			<v-divider/>
			<template v-if="loading">
				<v-tabs v-model="tabIndex" height="56">
					<v-tab>미발행({{ idle.totalCount.format() || 0 }})</v-tab>
					<v-tab>발행({{ issued.totalCount.format() || 0 }})</v-tab>
					<v-tab>취소({{ canceled.totalCount.format() || 0 }})</v-tab>
					<v-spacer/>
					<div class="d-flex mt-2 pr-6">
						<!-- <v-date-month v-if="0 < tabIndex":label="tabIndex == 1 ? '발행일자' : '취소일자'" /> -->
						<!-- <v-select label="상품권 이름(필터)" persistent-placeholder dense outlined hide-details class="ml-2" /> -->
					</div>
				</v-tabs>
				<v-divider/>
				<v-tabs-items v-model="tabIndex" touchless>
					<v-tab-item>
						<giftcard-pins :giftcard="giftcard" :filter="{ status: `미발행`, name: filter.name }" @search="summary => idle = summary" />
					</v-tab-item>
					<v-tab-item>
						<giftcard-pins :giftcard="giftcard" :filter="{ status: `발행완료`, name: filter.name, issuedAt: filter.date }" @search="summary => issued = summary" />
					</v-tab-item>
					<v-tab-item>
						<giftcard-pins :giftcard="giftcard" :filter="{ status: `취소완료`, name: filter.name, canceledAt: filter.date }" @search="summary => canceled = summary" />
					</v-tab-item>
				</v-tabs-items>
			</template>
			<template v-else>
            <v-layout align-center justify-center class="py-10">
                <v-progress-circular indeterminate color="primary" size="24" />
            </v-layout>
        </template>
		</v-card>
	</v-responsive>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import GiftcardPins from "@/components/console/shop/giftcards/giftcard-pins.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
	components: {
		GiftcardPins
	},
	props: {
		giftcard: { type: Object },
	},
	data() {
		return {
			mdiMicrosoftExcel, 
			loading: true,
			tabIndex: 0,

			filter: {
                menu: null,
                name: null,
            },

            idle: { totalCount: 0 },
            issued: { totalCount: 0 },
            canceled: { totalCount: 0 },

            summaries: [],
		}
	},
	methods: {
		async init() {
			await this.search();
		},
		async search() {
			if(!this.giftcard._id) return;
			this.loading = true;

			let { summaries } = await api.console.shop.giftcards.pins.summaries.gets(this.giftcard._id);
			this.summaries = summaries;
			this.idle.totalCount = summaries.reduce((totalCount, summary) => totalCount + (summary.status == "미발행" ? summary.totalCount : 0), 0);

			var { summary } = await api.console.shop.giftcards.pins.gets(this.giftcard._id, {
                headers: { skip: 0, limit: 1 },
                params: { status: "발행완료" },
            });

            this.issued.totalCount = summary.totalCount;

            var { summary } = await api.console.shop.giftcards.pins.gets(this.giftcard._id, {
                headers: { skip: 0, limit: 1 },
                params: { status: "취소완료" },
            });
            this.canceled.totalCount = summary.totalCount;
		},
		async excel(){
			let { pins } = await api.console.shop.giftcards.pins.gets(this.giftcard._id, {})

            var datas = [];
            pins.forEach(pin => {
                datas.push({
                    "상품권 이름": pin?.name,
                    "핀번호": pin?.pno,
                    "액면가": pin?.faceamt.format(),
                    "상태": pin?.status,
					"등록일자": pin?.createdAt ? this.$dayjs(pin?.createdAt).format("YYYY-MM-DD HH:mm:ss") : "-",
					"발행일자": pin?.issuedAt ? this.$dayjs(pin?.issuedAt).format("YYYY-MM-DD HH:mm:ss") : "-",
					"취소일자": pin?.canceledAt ? this.$dayjs(pin?.canceledAt).format("YYYY-MM-DD HH:mm:ss") : "-"
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(datas);

            XLSX.utils.book_append_sheet(workbook, worksheet, "핀번호 목록");
            XLSX.writeFile(workbook, "핀번호 목록.xlsx");
        }
	},
	async mounted() {
		await this.init();
	}
}
</script>

<style>

</style>